const urlServer = 'https://premexbel.by/premex/'
//const urlServer = 'https://oxsedu.site/premex/'
//const urlServer = 'https://oxsedu.site/premex/'
//const urlServer = 'http://localhost:5000/premex/'
//const urlServer = 'http://localhost:7020/premex/'

export {urlServer}